module.exports = __webpack_public_path__ + "static/microIntro-2d7f332726dd86b88b4667c48d59779f.mp4";